import React from 'react';
import './profile.css';

interface ProfileProps {
  onClose: () => void; // Callback to close the modal
}

const Profile: React.FC<ProfileProps> = ({ onClose }) => {
  const handleLogout = () => {
    // Remove keys from localStorage
    localStorage.removeItem('user');
    localStorage.removeItem('id_token');
    localStorage.removeItem('access_token');

    // Redirect to the origin
    window.location.href = '/'; // Redirect to the homepage
  };

  // Retrieve the user object from localStorage and extract the email
  const user = localStorage.getItem('user');
  const email = user ? JSON.parse(user).email : 'User'; // Default to "User" if email is not found

  return (
    <div className="profile-modal">
      <div className="profile-modal-content">
        <div>{email}</div> {/* Display the email address */}
        <div className="profile-modal-actions">
            <button
            onClick={onClose}
          >
            Cancel
          </button>
          <button className="primary-button"
            onClick={handleLogout}
          >
            Log out
          </button>
        
        </div>
      </div>
    </div>
  );
};

export default Profile;